import { Cookies } from "react-cookie";

const cookies = new Cookies();
const cookies_config = {
  maxAge: 1704085200,
  path: "/",
  secure: true,
  sameSite: "none",
};

export const setCookie = async (key, value) => {
  await cookies.set(key, value, cookies_config);
};

export const getCookie = async (key) => {
  return await cookies.get(key);
};

export const removeCookie = async (key) => {
  await cookies.remove(key, cookies_config);
};
